import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "react-axios";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";

import dayjs from "dayjs";
import { Helmet } from "react-helmet";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import UserFavoritesContainer from "./UserFavoritesContainer";
import TrackBoxes from "~/Components/Elements/TrackBoxes";
import UserFavoriteGenres from "./UserFavoriteGenres";
import UserFavoriteArtists from "./UserFavoriteArtists";

import UserProfileContainer from "./UserProfileContainer";
import UserSocialNetworks from "./UserSocialNetworks";

import { useUser } from "~/Context/userContext";
import { getUserPlaylists } from "~/api/getCustomPlaylists";
import PlaylistCard from "../Playlists/PlaylistCard";

const UserProfilePage = ({ match }) => {
  const { state: userState } = useUser();
  const [loading, setLoading] = useState(true);
  const [playlists, setPlaylists] = useState([]);
  const [page, setPage] = useState(1);
  const [userDir, setUserDir] = useState(match.params.userDir);
  const isSelf = userState.loggedin && userState.user && userState.user.dir === match.params.userDir;

  useEffect(() => {
    setUserDir(match.params.userDir);
  }, [match]);

  const load = async () => {
    const resp = await getUserPlaylists(axios, match.params.userDir, 20);
    // console.log("🚀 ~ file: ChimneyPlaylistPage.js:17 ~ load ~ resp:", resp);
    setPlaylists(resp.data.playlists);
    setLoading(false);
  };
  useEffect(() => {
    load();
  }, []);

  const dateFormatter = (date) => {
    return dayjs(date.split("T")[0]).format("MMM D, YYYY");
  };

  const pagination = (page) => {
    setPage(page);
    window.scrollTo(0, 0);
  };

  return (
    <div className="totd-page-general user-profile-page">
      <UserProfileContainer
        userDir={userDir}
        render={({ profile }) => {
          return (
            <React.Fragment>
              <Helmet>
                <title>{profile.full_name} | Dream Chimney</title>
              </Helmet>
              <Row className="with-col-list">
                <Col xs={12} md={3}>
                  <div style={{ marginBottom: "20px" }}>
                    <h2>{profile.full_name}</h2>
                    <div style={{ fontSize: "12px" }}>Member since: {dateFormatter(profile.created_at)}</div>
                  </div>

                  <div style={{ marginBottom: "30px" }}>{profile.avatar && <img src={profile.avatar} style={{ maxWidth: "150px" }} />}</div>

                  <UserSocialNetworks isSelf={isSelf} profile={profile} userDir={match.params.userDir} />
                </Col>
                <Col xs={12} md={9} style={{ marginTop: "12px" }}>
                  <UserFavoriteArtists dir={userDir} />
                  <UserFavoriteGenres dir={userDir} />

                  <UserFavoritesContainer
                    userDir={userDir}
                    page={page}
                    render={({ tracks, more }) => {
                      return (
                        <div>
                          <div className="totd-header mb">
                            <h3>Favorite Tracks</h3>
                          </div>
                          {tracks.length === 0 && (
                            <Row>
                              <Col xs={12}>
                                <div>No favorite tracks yet...</div>
                                {isSelf && (
                                  <div>
                                    <br />
                                    <FontAwesomeIcon icon={["far", "lightbulb"]} style={{ fontSize: "30px", marginRight: "10px" }} /> To add
                                    favorite tracks, click the heart icon <FontAwesomeIcon icon={["far", "heart"]} /> next to each track.
                                  </div>
                                )}
                              </Col>
                            </Row>
                          )}

                          <Row>
                            <Col xs={12}>
                              <TrackBoxes tracks={tracks} />
                            </Col>
                          </Row>
                          <Row>
                            <Col xs={12}>
                              <div className="center-block col-text-center">
                                {page > 1 && (
                                  <button className="pagination pagination-item" onClick={() => pagination(page - 1)}>
                                    Previous
                                  </button>
                                )}

                                {more === true && (
                                  <button className="pagination pagination-item" onClick={() => pagination(page + 1)}>
                                    Next
                                  </button>
                                )}
                              </div>
                            </Col>
                          </Row>
                        </div>
                      );
                    }}
                  />
                  <Row>
                    <Col xs={12} style={{ marginTop: 20 }}>
                      <div className="totd-header mb">
                        <h3>Playlists</h3>
                      </div>
                      {playlists.length ? (
                        playlists.length !== 0 && (
                          <>
                            <Row>
                              {playlists.map((p) => (
                                <Col xs={12} sm={12} md={6} lg={4}>
                                  <PlaylistCard p={p} />
                                </Col>
                              ))}
                            </Row>
                          </>
                        )
                      ) : loading ? (
                        <div>Loading...</div>
                      ) : (
                        <div>
                          <p>You have not created any Playlists yet.</p>
                          <p>Next to each track, click the "Add to Playlist" button and create a playlist with that track.</p>
                        </div>
                      )}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </React.Fragment>
          );
        }}
      />
    </div>
  );
};

export default UserProfilePage;
